<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>Cấu hình ghép workflow</h1>

          <div style="float: right">
            <button type="button" @click="$router.push('/ticket-category')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">Lưu</button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="codeInfo px-20 row col-4">
            <div>Mã danh mục ticket: {{ dataRequest.code }}</div>
            <div>Mã Workflow: {{ dataRequest.processWorkflowId }}</div>
          </div>

          <div class="card-body px-20 row col-9">
            <table>
              <thead>
                <tr>
                  <th>Trường dữ liệu trong workflow</th>
                  <th>Trường dữ liệu trong ticket</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(config, index) in configs" :key="index">
                  <td>
                    <Select2
                      v-model="config.workflowFieldName"
                      :options="getComputedOptions(config)"
                    >
                      <template #option="{ option }">
                        <div :disabled="config.workflowFieldName === option">
                          {{ option }}
                        </div>
                      </template>
                    </Select2>
                  </td>
                  <td>
                    <input type="text" v-model="config.ticketFieldName" />
                  </td>
                  <td>
                    <div class="pointer" @click="deleteRow(index)">X</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <button type="button" class="btn btn-light ml-2" @click="addRow">Thêm</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { TicketService } from '@/services/ticket.service'
  export default {
    name: 'ticket-group-request',
    data() {
      return {
        dataRequest: {},
        showLoading: false,
        configs: [{ ticketFieldName: '', workflowFieldName: '' }],
        dataVariable: [],
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        const ticketId = this.$route.params.id
        try {
          this.showLoading = true
          const responsive = await TicketService.getDetailCategory({
            id: ticketId,
          })
          this.dataRequest = responsive.data
          this.configs = responsive.data.configs
          responsive.data.configs.map(e => {
            const arr = e.workflowFieldName
            this.dataVariable.push(arr)
          })
          this.fetchDataVariable(responsive.data.processWorkflowId)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchDataVariable() {
        try {
          this.showLoading = true
          const responsive = await TicketService.getVariable({
            processWorkflowId: this.dataRequest.processWorkflowId,
          })
          if (responsive) {
          }
          this.dataVariable = this.dataVariable.concat(
            responsive.data.filter(item => this.dataVariable.indexOf(item) < 0)
          )
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      addRow() {
        this.configs.push({ ticketFieldName: '', workflowFieldName: '' })
      },
      deleteRow(index) {
        this.configs.splice(index, 1)
      },
      async submitRequest() {
        try {
          const params = {
            categoryId: this.dataRequest.id,
            configs: this.configs,
          }
          this.showLoading = true
          const response = await TicketService.createConfigWorkflow(params)
          if (response.code === 1000) {
            this.showSuccessMx('Cấu hình workflow thành công').then(() =>
              this.$router.push('/ticket-category')
            )
          } else this.showFailMx(response.message)
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
      getComputedOptions(config) {
        return this.dataVariable.filter(
          option =>
            !this.configs.some(c => c.workflowFieldName === option) ||
            option === config.workflowFieldName
        )
      },
    },
  }
</script>

<style scoped>
  table {
    border-collapse: collapse;
    width: 100%;
    text-align: left;
    font-size: 14px;
  }

  th,
  td {
    padding: 8px;
  }

  th {
    color: #333;
    font-weight: bold;
    text-align: center;
  }
  table td {
    border: solid 1px #fff;
  }
  .pointer {
    cursor: pointer;
    font-size: 20px;
  }
  .codeInfo {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 25px;
  }
</style>
